import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toaster } from "@/components/ui/toaster";

export function useAutosaveFeedback({
    isUpdateInvoiceError,
    isUpdateInvoiceSuccess
}: {
    isUpdateInvoiceError: boolean;
    isUpdateInvoiceSuccess: boolean;
}) {
    const lastWasError = useRef(false);
    const { t } = useTranslation("invoices");

    useEffect(() => {
        // Show error only once per failure streak
        if (isUpdateInvoiceError && !lastWasError.current) {
            toaster.create({
                id: "autosaveFailed",
                title: t("errorMessages:autosaveFailedMsg"),
                type: "error",
                closable: true
            });
            lastWasError.current = true;
        }

        // Reset on next success
        if (isUpdateInvoiceSuccess && lastWasError.current) {
            lastWasError.current = false;
        }
    }, [isUpdateInvoiceError, isUpdateInvoiceSuccess, t]);
}
